export default __webpack_public_path__ + "static/media/dedicated.468f1dcf.jpg";